module.exports = __webpack_public_path__ + "_/skins/MacOSXAqua1-5-88dbd4e043795c98625462a908a2d965.wsz";